import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconComponent } from '@fc-shared/ui/icon/icon.component';
import { NgTagComponent } from '@fc-shared/ui/tags/ng-tag.component';
import { ButtonComponent } from '@fc-shared/ui/buttons/button.component';

@Component({
  selector: 'fc-quick-search-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, RouterLink, NgTagComponent, ButtonComponent],
  template: `
    <div
      class="hidden md:flex items-center gap-8 px-20 h-44 border-t border-secondary-100 text-sm text-secondary-400 bg-secondary-50"
    >
      <span class="flex items-center gap-4"> Use </span>
      <fc-ng-tag color="secondary" size="small" icon="icon-arrow-up" />
      <fc-ng-tag color="secondary" size="small" icon="icon-arrow-down" />
      <span>,</span>
      <fc-ng-tag color="secondary" size="small" icon="icon-arrow-back" />
      <fc-ng-tag color="secondary" size="small" icon="icon-arrow-forward" />
      <span class="flex items-center gap-4"> to navigate </span>
      <fc-ng-tag color="secondary" size="small">Enter</fc-ng-tag>
      <span class="flex items-center gap-4"> to select </span>
      <a
        [routerLink]="['/search']"
        [queryParams]="viewAllParams()"
        (click)="searchCleared.emit()"
        class="ml-auto flex items-center gap-4 text-primary-600"
      >
        <fc-icon icon="icon-search-outline" [size]="16" color="primary600" />
        Try Advanced Search
      </a>
    </div>
    <div
      class="flex md:hidden items-center gap-8 px-16 py-10 border-t border-secondary-100 text-sm text-secondary-400"
    >
      <fc-button
        variant="outline"
        color="secondary"
        [queryParams]="viewAllParams()"
        [routerLink]="['/search']"
        (click)="searchCleared.emit()"
        size="sm"
        class="ml-auto"
        icon="icon-search-outline"
      >
        Try Advanced Search
      </fc-button>
    </div>
  `,
})
export class QuickSearchFooterComponent {
  viewAllParams = input.required<Record<string, string>>();
  searchCleared = output<void>();
}
